import React from 'react';
import { FixedSizeList } from 'react-window';

export const InfiniteScroll = ({ref,onScroll,itemCount,height,width,itemSize,children}) => {
    return (
        <FixedSizeList
        height={height}
        itemCount={itemCount}
        itemSize={itemSize} 
        width={width}
        onScroll={onScroll}
        ref={ref}
      >
        {children}
      </FixedSizeList>
    );
};

